module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-load-breakdown"
  }, [_vm._l((_vm.loadsOrderedByLoadingDate), function(load, index) {
    return _c('client-load', {
      key: load.id,
      attrs: {
        "load": load,
        "index": index
      }
    })
  }), _vm._v(" "), (_vm.haveNoLoads) ? _c('li', {
    staticClass: "text-center text-muted"
  }, [_vm._v("\n        There are no loads.\n      ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_c('p', {
    staticClass: "assigned"
  }, [_vm._v("Assigned: " + _vm._s(_vm.loadSize) + " of " + _vm._s(_vm.jobSize) + " tonnes. (" + _vm._s(_vm.loadPercentage) + "%)")])]), _vm._v(" "), (_vm.haveLoadWithWeighbridge) ? _c('load-check-modal') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("Load Details")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-39d1d9d0"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/loads/ClientLoadList.vue
// module id = 969
// module chunks = 0